import { render, staticRenderFns } from "./PortfolioUploadStatus.vue?vue&type=template&id=2285e3e1&scoped=true&"
import script from "./PortfolioUploadStatus.vue?vue&type=script&lang=js&"
export * from "./PortfolioUploadStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2285e3e1",
  null
  
)

export default component.exports